import { Resume } from '@sr/types';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useResume } from 'v1/hooks/use-resume';

const ResumeStateContext = React.createContext<Resume | null | undefined>(
  undefined
);

function ResumeProvider({ children }: { children: React.ReactNode }) {
  const { resumeId } = useParams<{ resumeId?: string }>();
  const resume = useResume(resumeId);
  return (
    <ResumeStateContext.Provider value={resume}>
      {children}
    </ResumeStateContext.Provider>
  );
}

function useActiveResume() {
  const context = React.useContext(ResumeStateContext);
  if (context === undefined) {
    throw new Error('useActiveResume must be used within a ResumeProvider');
  }
  return context;
}

export { ResumeProvider, useActiveResume };
